<template>
	<section id="component-minha-localizacao" v-show="exibir_">
		<div class="container-modal">
			<div class="container-conteudo">
				<div class="modal-header">
					<h3 class="font-24 head-bold">Minha localização</h3>
					<button type="button" class="close" @click="fechar">
						<span aria-hidden="true">&times;</span>
					</button>
				</div>
				<!-- Default -->
				<div class="row-content" v-if="!selected.cidade">
					<div class="mx-auto text-center static-mb-32 max-w-full md:max-w-xs">
						<button class="btn__primary" @click="encontrarLocalizacaoBrowser"><i class="fas fa-map-marker-alt"></i>{{ labelBotaoLocalizacao }}</button>
					</div>
					<p class="font-16 grey400 py-0 head-regular static-mb-32">Clique no botão acima para identificarmos automaticamente sua localização.</p>
					<p class="font-16 p-0 m-0 static-mb-8 head-regular">Ou informe manualmente</p>

					<div>
						<base-input v-if="!carregando" label="name" track-by="name" placeholder="Digíte o CEP" class="epeca-multi-select" :string-mask="['########']" @input="getDropdownValues" />
						<div class="box-input-fake">
							<Loader v-if="carregando"></Loader>
						</div>
					</div>
					<div v-if="errorGeolocation !== ''" class="font-16 p-0 m-0 static-mt-16 head-regular">
						{{ errorGeolocation }}
					</div>
				</div>
				<div class="row-content p00" v-if="selected.cidade">
					<div class="etapa-de-confirmar">
						<div class="box-de-confirmacao">
							<div class="mb-4">
								<b class="head-regular">Você está em </b>
							</div>

							<div class="box-input-fake" v-if="loadingGeolocation">
								<ViewCarregando v-if="loadingGeolocation" img-small></ViewCarregando>
							</div>
							<div v-else class="text-center mb-4">
								<div v-if="!exibirCepEtapaFinal">
									<span class="cidade-cep head-regular">{{ this.selected.cidade }}</span>
								</div>
								<div v-if="exibirCepEtapaFinal">
									<span class="cidade-cep head-regular">{{ this.selected.cidade }}</span>
									<span class="font25"> <span class="mobile-none"> -</span> CEP </span>
									<span class="cidade-cep head-regular">
										{{ this.selected.cep }}
									</span>
								</div>
							</div>
							<div class="text-center">
								<button class="btn__primary" v-if="!loadingGeolocation" @click="confirmarCidade()">Confirmar</button>
							</div>
						</div>
					</div>
					<mq-layout mq="lg+">
						<div class="box-de-confirmacao head-regular">
							Está incorreto, quero

							<button class="link" @click="selecionarOutraCidade()">
								<span>informar outro CEP ou selecionar outra cidade</span>
							</button>
						</div>
					</mq-layout>
					<mq-layout :mq="['xs', 'sm', 'md']">
						<div class="box-de-confirmacao">
							Está incorreto, quero
							<button class="link" @click="selecionarOutraCidade()">
								<span>selecionar outra cidade</span>
							</button>
						</div>
					</mq-layout>
				</div>
				<div class="row-footer">
					<div class="max-w-full md:max-w-xs">
						<button class="btn__primary--outline" @click="fechar">Fechar</button>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import authMixin from "@/mixins/auth"
import Dropdown from "vue-simple-search-dropdown"
import DefaultButton from "@/components/Common/DefaultButton"
import { TheMask } from "vue-the-mask"
import ViewCarregando from "@/components/ViewCarregando.vue"
import Loader from "@/components/Common/Loader.vue"
import axios from "axios"
import Multiselect from "vue-multiselect"
import BaseInput from "./BaseInput.vue"

let API_B2C_BACKEND = process.env.API_B2C_BACKEND
const TOKEN_EPA = process.env.TOKEN_EPA

export default {
	name: "ComponentMinhaLocalizacao",
	mixins: [authMixin],
	props: {
		configMinhaLocalizacao: {
			type: Object,
			required: true,
		},
	},
	components: {
		Dropdown,
		"the-mask": TheMask,
		ViewCarregando,
		Multiselect,
		DefaultButton,
		BaseInput,
		Loader,
	},
	data() {
		return {
			value: null,
			localizacao: {
				latitude: 0,
				longitude: 0,
			},
			exibir_: false,
			selected: { cidade: null, cep: null },
			cidades: [],
			carregando: false,
			requisicaoEmAndamento: false,
			cidadeSemCep: false,
			primeiroPasso: true,
			cepDigitado: "",
			cepVerificado: false,
			exibirCepEtapaFinal: false,
			labelBotaoLocalizacao: "Minha localização",
			loadingGeolocation: false,
			errorGeolocation: "",
		}
	},
	mounted() {
		this.exibir_ = this.configMinhaLocalizacao.exibir
	},
	computed: {
		cidadeSelecionada() {
			return this.$store.getters["cidadeSelecionada"]
		},
		selecionouCidade() {
			return this.$store.getters["selecionouCidade"]
		},
	},
	methods: {
		nameWithLang({ name, language }) {
			return `${name}`
		},
		reset() {
			;(this.localizacao = {
				latitude: 0,
				longitude: 0,
			}),
				(this.selected = { cidade: null, cep: null }),
				(this.cidadeParaConfirmar = { cidade: null, cep: null }),
				(this.carregando = false),
				(this.requisicaoEmAndamento = false),
				(this.cidadeSemCep = false),
				(this.primeiroPasso = true),
				(this.cepDigitado = ""),
				(this.cepVerificado = false)
			this.exibirCepEtapaFinal = false
		},
		geoSuccess(position) {
			this.localizacao.latitude = position.coords.latitude
			this.localizacao.longitude = position.coords.longitude
			this.buscarCidadePorLatLong()
		},
		geoError(err) {
			this.carregando = false
			this.labelBotaoLocalizacao = "Minha localização"
			switch (err.code) {
				case 1:
					// permissão negada pelo usuario
					console.log("geolocalização: solicitação não aceita pelo usuário")
					break

				case 2:
					// nao foi possível alcançar os satélites GPS
					console.log("geolocalização: não foi possível alcançar os satélites GPS")
					break

				case 3:
					// a requisição demorou demais para retornar
					console.log("geolocalização: a requisição demorou demais para retornar")
					break

				case 0:
					// ocorreu um erro desconhecido...
					console.log("geolocalização: ocorreu um erro desconhecido...")
					break
			}
		},
		encontrarLocalizacaoBrowser() {
			this.carregando = true
			this.labelBotaoLocalizacao = "Aguarde..."
			navigator.geolocation.getCurrentPosition(this.geoSuccess, this.geoError)
		},
		buscarCidadePorLatLong() {
			this.loadingGeolocation = false
			axios
				.post(this.configMinhaLocalizacao.endpoint.postLocalidadePorLatLong, {
					lat: this.localizacao.latitude,
					long: this.localizacao.longitude,
				})
				.then((response) => {
					const data = response.data.data
					this.selected.cep = data.cep
					this.selected.cidade = data.cidade
					if (data.lojas_prioritarias) {
						this.selected.lojas_prioritarias = data.lojas_prioritarias
					}
					this.selected = data
					this.cidadeSemCep = false
					this.primeiroPasso = false
					this.cepVerificado = true
					this.carregando = false
					this.labelBotaoLocalizacao = "Minha localização"
				})
				.catch((error) => {
					console.log(error.message)
					this.carregando = false
					this.labelBotaoLocalizacao = "Minha localização"
					this.loadingGeolocation = false
				})
		},
		async buscarCidadePorCep(cep) {
			this.carregando = true
			this.loadingGeolocation = true
			this.errorGeolocation = ""

			try {
				const res = await this.$axios.post(API_B2C_BACKEND + `/geolocalizacao?token=${TOKEN_EPA}`, {
					cep: cep,
				})
				const data = res.data.data
				if (data.cepNaoEncontrado) {
					this.reset()
					this.errorGeolocation = res.data.message
				} else {
					this.errorGeolocation = ""
					this.selected.cep = data.cep
					this.selected.cidade = data.cidade
					if (data.lojas_prioritarias) {
						this.selected.lojas_prioritarias = data.lojas_prioritarias
					}
					this.selected = data
					this.cidadeSemCep = false
					this.primeiroPasso = false
					this.cepVerificado = true
					this.carregando = false
				}
			} catch (error) {
				this.reset()
				this.errorGeolocation = error.response.data.message
			}

			this.carregando = false
			this.loadingGeolocation = false
		},
		fechar() {
			this.reset()
			this.$eventbus.$emit("ComponentMinhaLocalizacao/fechar", true)
		},
		selecionarOutraCidade() {
			this.reset()
		},
		carregarListaCidades() {
			this.carregando = true
			axios
				.get(this.configMinhaLocalizacao.endpoint.getTodasCidades)
				.then((response) => {
					const data = response.data.data
					let dadosPreparados = []
					data.forEach((cidade) => {
						dadosPreparados.push({
							id: cidade.cep,
							name: cidade.cidade,
						})
					})
					this.cidades = dadosPreparados
					this.carregando = false
				})
				.catch((error) => {})
		},
		getDropdownValues(pesquisa, id) {
			let regexCep = /\d{5}[-\s]?\d{3}/g
			let eCep = false

			if (pesquisa.length === 8 || pesquisa.length === 9) {
				eCep = regexCep.test(pesquisa)
			}
			if (eCep) {
				this.carregando = true
				this.buscarCidadePorCep(pesquisa)
			}
		},
		validateSelection(cidadeSelecionada) {
			if (!this.requisicaoEmAndamento) {
				this.selected.cep = cidadeSelecionada.id
				this.selected.cidade = cidadeSelecionada.name
			}

			if (this.selected.cep && !this.requisicaoEmAndamento) {
				this.requisicaoEmAndamento = true
				this.cidadeSemCep = false
				this.primeiroPasso = false
				this.cepVerificado = true
				this.buscarCidadePorCep(this.selected.cep)
			} else if (this.selected.cep === null && !this.requisicaoEmAndamento) {
				this.requisicaoEmAndamento = true
				this.cidadeSemCep = true
				this.primeiroPasso = false
			}
		},
		pesquisaPorCep() {
			if (this.cepDigitado.length == 8) {
				this.exibirCepEtapaFinal = true
				this.buscarCidadePorCep(this.cepDigitado)
			}
		},
		confirmarCidade() {
			this.$emit("confirmou-nova-cidade", this.selected)
			// Insere os Ids das Lojas recebidos do BE (availableStores)
			if (this.selected.lojas_prioritarias) {
				this.$store.dispatch("setStoreIds", this.selected.lojas_prioritarias)
			}

			this.$storage.setUniversal("geolocation", this.selected)

			this.$eventbus.$emit("Cep/cepChange")
			this.reset()
			this.$eventbus.$emit("ComponentMinhaLocalizacao/fechar", true)
		},
	},
	watch: {
		"configMinhaLocalizacao.exibir"(exibir) {
			this.exibir_ = exibir
			if (this.exibir_) {
				if (this.selecionouCidade) {
					let geolocation = this.$cookies.get("geolocation")
					this.selected.cidade = geolocation.cidade
					this.selected.cep = geolocation.cep
				} else {
					this.selected.cidade = null
					this.selected.cep = null
					this.errorGeolocation = ""
				}
			}
		},
	},
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
.multiselect__option--highlight {
	background: #f0f0f0;
	color: #000;
}
.container-dropdown-minha-localizacao {
	input.dropdown-input {
		display: block !important;
		width: 100% !important;
		max-width: 100% !important;
		height: 3em !important;
		font-size: 1em !important;
	}
	.dropdown-content {
		width: 100% !important;
		max-width: 100% !important;
		.dropdown-item {
			font-size: 1em !important;
		}
	}
}
</style>
<style lang="scss" scoped>
#component-minha-localizacao {
	.container-modal {
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: rgba(0, 0, 0, 0.5);
		height: 100%;
		left: 0;
		position: fixed;
		top: 0;
		width: 100%;
		z-index: 100000;
		.container-conteudo {
			background-color: #fff;
			border-radius: 0.3rem;
			box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.2);
			position: relative;
			width: 700px;
			@media (max-width: 767px) {
				width: 90%;
				.box-cidade-selecionda {
					.flex-between {
						display: block;
					}
					.cidade {
						display: block;
						padding: 1em 0;
					}
				}
				.cidade-cep:first-child {
					display: block;
				}
				.mobile-none {
					display: none;
				}
			}
			.row-header {
				display: flex;
				align-items: center;
				border-bottom: 1px solid #ddd;
				margin: 0;
				padding: 1em;
				h5 {
					flex: 1;
					color: #666;
					font-size: 1em;
					margin: 0;
					padding: 0;
				}
				button {
					background-color: transparent;
					border: none;
					color: #666;
					font-size: 1.5em;
					outline: 0;
					padding: 0;
				}
			}
			.row-content {
				margin: 0;
				padding: 1em;
				.btn-encontrar-localizacao {
					background: #0e408f 0% 0% no-repeat padding-box;
					border-radius: 5px;
					opacity: 1;
					color: #fff;
					width: 100%;
					padding: 10px 12px;
					margin: 0 auto 10px;
					border: none;
					span {
						font-size: 21px;
						i {
							margin-right: 10px;
						}
					}
				}
				.box-input-fake {
					width: 100%;
					display: flex;
					align-items: center;
					justify-content: center;
				}
				.box-cidade-selecionda {
					margin-top: 10px;
					margin-bottom: 15px;
					.cidade {
						margin-top: 10px;
						font-size: 21px;
						font-weight: 600;
						letter-spacing: 0px;
						color: #0e408f;
					}
					.selecionar-outra-cidade {
						color: #212529;
						text-decoration: underline;
						font-weight: 600;
					}
				}
				.box-input-cep {
					input,
					input:focus,
					input:active {
						border: 1px solid #ddd;
						border-radius: 4px;
						box-sizing: border-box;
						padding: 0.4em 0.6em;
						width: 100%;
					}
				}
				.etapa-de-confirmar {
					background: #f4f4f4;
					padding: 3em 1em;
					display: flex;
					justify-content: center;
					.font25 {
						font-size: 25px;
					}
					.cidade-cep {
						// margin-top: 10px;
						// font-size: 25px;
						// font-weight: 600;
						// letter-spacing: 0px;
						// color: #0e408f;
					}
					.btn-confirmar {
						background: #0e408f 0% 0% no-repeat padding-box;
						border-radius: 5px;
						opacity: 1;
						color: #fff;
						width: 200px;
						padding: 10px 12px;
						margin: 0 auto 10px;
						border: none;
					}
				}
				.box-de-confirmacao {
					margin: 0;
					padding: 1em;
					text-align: center;
					.selecionar-outra-cidade {
						color: #212529;
						text-decoration: underline;
					}
				}
			}
			.row-footer {
				display: block;
				border-top: 1px solid #ddd;
				margin: 0;
				padding: 16px;
				@media (min-width: 768px) {
					display: flex;
					justify-content: flex-end;
				}
			}
		}
	}
	.flex-between {
		display: flex;
		justify-content: space-between;
	}
	.p00 {
		padding: 0 !important;
	}
	.mb05 {
		margin-bottom: 5px;
	}
	.mb10 {
		margin-bottom: 10px;
	}
	.mb20 {
		margin-bottom: 20px;
	}
}
.btn-confirmar:disabled {
	opacity: 0.4 !important;
}
</style>
